import React, { useState, useEffect, useRef } from "react";
import Header from "./Header.js";
import Footer from "./Footer.js";
// import { TailSpin } from "react-loader-spinner";
import Select from "react-select";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Style.css";
import Add_Instructor_Categories from "../../Components/instructor_comp/add_categories.js";
import Update_Instructor_Categories from "../../Components/instructor_comp/update_categories.js";
import Delete_Instructor_Categories from "../../Components/instructor_comp/delete_categories.js";

function Instructor_Categories() {
  const [
    modalAdd_Instructor_CategoriesIsOpen,
    setAdd_Instructor_CategoriesModalIsOpen,
  ] = useState(false);
  const [
    modalUpdate_Instructor_CategoriesIsOpen,
    setUpdate_Instructor_CategoriesModalIsOpen,
  ] = useState(false);
  const [
    modalDelete_Instructor_CategoriesIsOpen,
    setDelete_Instructor_CategoriesIsOpen,
  ] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const Status = [
    { value: "All", label: "All" },
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];
  const openAdd_Instructor_Categories = () => {
    closeAdd_Instructor_Categories();
    setAdd_Instructor_CategoriesModalIsOpen(true);
  };

  const closeAdd_Instructor_Categories = () => {
    setAdd_Instructor_CategoriesModalIsOpen(false);
  };

  const openUpdate_Instructor_Categories = () => {
    closeUpdate_Instructor_Categories();
    setUpdate_Instructor_CategoriesModalIsOpen(true);
  };

  const closeUpdate_Instructor_Categories = () => {
    setUpdate_Instructor_CategoriesModalIsOpen(false);
  };
  const openDelete_Instructor_Categories = (userId) => {
    setSelectedUserId(userId);
    closeDelete_Instructor_Categories();
    setDelete_Instructor_CategoriesIsOpen(true);
  };

  const closeDelete_Instructor_Categories = () => {
    setDelete_Instructor_CategoriesIsOpen(null);
  };

  return (
    <div>
      <Header></Header>
      {modalAdd_Instructor_CategoriesIsOpen && (
        <Add_Instructor_Categories onClose={closeAdd_Instructor_Categories} />
      )}
      {modalUpdate_Instructor_CategoriesIsOpen && (
        <Update_Instructor_Categories
          onClose={closeUpdate_Instructor_Categories}
        />
      )}
      {modalDelete_Instructor_CategoriesIsOpen && (
        <Delete_Instructor_Categories
          userId={selectedUserId}
          onClose={closeDelete_Instructor_Categories}
        />
      )}
      <main id="main" class="main">
        <div class="pagetitle">
          <h1> Categories</h1>
          {/* <nav>
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="/categories">Home</a>
              </li>
              <li class="breadcrumb-item active">Categories</li>
            </ol>
          </nav> */}
        </div>
        <section class="section">
          <div class="card p-2">
            <div class="parent col-md-12 row mt-2">
              <div class="col-md-6">
                <div class="child">
                  <input
                    id="myInput"
                    type="text"
                    style={{
                      borderRadius: "5px",
                      height: "35px",
                      padding: "10px",
                      border: "1px solid lightgrey ",
                    }}
                    placeholder="Search..."
                  />
                </div>
                <div class="child ml-2">
                  <Select options={Status} placeholder="Select Status"></Select>
                </div>
              </div>
              <div class="col-md-6" style={{ textAlign: "right" }}>
                <div class="child">
                  <a>
                    <button
                      id="btnNewUser"
                      type="button"
                      data-toggle="modal"
                      data-target="#modalAdd"
                      class="btn-round"
                      onClick={openAdd_Instructor_Categories}
                    >
                      <i class="bi bi-person-add"></i> Add Categories
                    </button>
                  </a>
                </div>
              </div>
            </div>

            <div
              style={{ marginTop: "50px", display: "flex", marginLeft: "50%" }}
            >
              {/* <TailSpin color="black" width={50} /> */}
            </div>
            <table class="table table-striped  ">
              <thead>
                <tr>
                  <th scope="col">Sr.No</th>
                  <th scope="col">Name</th>
                  <th scope="col">Description</th>
                  <th scope="col">Category Tag</th>
                  <th scope="col">Status</th>
                  <th scope="col">Show on Home Page</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">1</th>
                  <td>Mark</td>
                  <td>Otto</td>
                  <td>@mdo</td>
                  <td>@mdo</td>
                  <td>@mdo</td>
                  <td>
                    <div className="social-links mt-2">
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={openUpdate_Instructor_Categories}
                      >
                        {" "}
                        <i class="bi bi-pencil"></i>
                      </a>
                      &nbsp;&nbsp;
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={openDelete_Instructor_Categories}
                      >
                        {" "}
                        <i class="bi bi-trash3"></i>
                      </a>
                      &nbsp;
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">2</th>
                  <td>Mark</td>
                  <td>Otto</td>
                  <td>@mdo</td>
                  <td>@mdo</td>
                  <td>@mdo</td>
                  <td>
                    <div className="social-links mt-2">
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={openUpdate_Instructor_Categories}
                      >
                        {" "}
                        <i class="bi bi-pencil"></i>
                      </a>
                      &nbsp;&nbsp;
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={openDelete_Instructor_Categories}
                      >
                        {" "}
                        <i class="bi bi-trash3"></i>
                      </a>
                      &nbsp;
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">3</th>
                  <td>Mark</td>
                  <td>Otto</td>
                  <td>@mdo</td>
                  <td>@mdo</td>
                  <td>@mdo</td>
                  <td>
                    <div className="social-links mt-2">
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={openUpdate_Instructor_Categories}
                      >
                        {" "}
                        <i class="bi bi-pencil"></i>
                      </a>
                      &nbsp;&nbsp;
                      <a
                        style={{ cursor: "pointer" }}
                        onClick={openDelete_Instructor_Categories}
                      >
                        {" "}
                        <i class="bi bi-trash3"></i>
                      </a>
                      &nbsp;
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </main>
      <Footer></Footer>
    </div>
  );
}

export default Instructor_Categories;
